import { useParams } from 'react-router-dom';

import { stringFormatter } from '@nhl/formatter-utilities';

import { Franchise, Team } from '../../../types/FranchiseTypes';

import { useFranchisesQuery } from './index';

const triCode = window.recordsSettings?.franchiseTricode;

export const getSelectedFranchise = () => {
    const params = useParams();
    const { data: franchises = [] } = useFranchisesQuery({});
    return franchises?.find((franchise) =>
        triCode === 'nhl' ? franchise.slug === params.slug : franchise.teamAbbrev === triCode.toUpperCase()
    ) as Franchise;
};

export const getActiveTeam = (franchise) => franchise?.teams?.find((team) => team.id === franchise.mostRecentTeamId);

export const getActiveTeams = () => {
    const { data: franchises = [] } = useFranchisesQuery({});
    return franchises
        .filter((franchise) => franchise.lastSeasonId === null)
        .map((franchise) => getActiveTeam(franchise)) as Team[];
};

const normalizeRepeatedTeamNames = (franchises) => {
    //This remove the (1917) and (1979) from the Winnipeg Jets and Ottawa Senators commonName strings.
    const ORIGINAL_OTTAWA_SENATORS_FRANCHISE_ID = 3;
    const ORIGINAL_OTTAWA_SENATORS_TEAM_ID = 36;
    const ORIGINAL_WINNIPEG_JETS_FRANCHISE_ID = 28;
    const ORIGINAL_WINNIPEG_JETS_TEAM_ID = 33;

    return franchises.map((franchise) => {
        if (franchise.id === ORIGINAL_OTTAWA_SENATORS_FRANCHISE_ID) {
            const team = franchise.teams.findIndex((team) => team.id === ORIGINAL_OTTAWA_SENATORS_TEAM_ID);
            franchise.teams[team].commonName =
                franchise.teams[team].commonName.slice(-7) === ' (1917)'
                    ? franchise.teams[team].commonName.slice(0, -7)
                    : franchise.teams[team].commonName;
            return franchise;
        } else if (franchise.id === ORIGINAL_WINNIPEG_JETS_FRANCHISE_ID) {
            const team = franchise.teams.findIndex((team) => team.id === ORIGINAL_WINNIPEG_JETS_TEAM_ID);
            franchise.teams[team].commonName =
                franchise.teams[team].commonName.slice(-7) === ' (1979)'
                    ? franchise.teams[team].commonName.slice(0, -7)
                    : franchise.teams[team].commonName;
            return franchise;
        } else {
            return franchise;
        }
    });
};

export const mergeFranchiseData = (franchiseData, data) =>
    data
        .filter((record) => record.opponentFranchiseId <= 99) //filter out non-NHL teams
        .map((record) => {
            const franchise = franchiseData.find((opponent) => opponent.id === record.opponentFranchiseId);
            const opponent = franchise?.teams?.find((team) => team.id === record.opponentTeamId);
            const activeTeam = franchise?.teams?.find(
                (team) => team.franchiseTeam[0].lastSeason?.id == franchise.lastSeasonId
            );

            return {
                ...record,
                opponentFranchiseName: activeTeam.fullName,
                opponent,
                activeTeam,
            };
        });

export const transformFranchiseData = ({ data }) => {
    const sluggedTeams = data.map((team) => ({
        ...team,
        slug: encodeURI(stringFormatter.toSlug(team.fullName)),
    }));
    return normalizeRepeatedTeamNames(sluggedTeams);
};
